import React, { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import { Paper, IconButton, Box , Typography} from "@mui/material";
import { Trash2 as DeleteIcon } from "lucide-react";

// DnD types
export const ItemTypes = { PALETTE: "palette", FIELD: "field" };

export const DraggablePaletteItem = ({ tmpl }) => {
  const [, drag] = useDrag({
    type: ItemTypes.PALETTE,
    item: { ...tmpl, options: tmpl.options || [] },
  });
;
  return (
    <Paper
      ref={drag}
      elevation={1}
      sx={{
        display: "flex",
        alignItems: "center",
        p: 2,
        mb: 2,
        borderRadius: 2,
        cursor: "grab",
        transition: "transform 0.2s, box-shadow 0.2s",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: 4,
        },
      }}
    >
      <Box
        sx={{
          mr: 1,
        }}
      >
        {tmpl.icon}
      </Box>

      {/* Label */}
      <Typography variant="body1">{tmpl.label}</Typography>
    </Paper>
  );
};

export const DraggableInput = ({ index, children, moveField ,onRemove}) => {
  const ref = useRef(null);
  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.FIELD,
    item: { index },
    collect: (m) => ({ isDragging: m.isDragging() }),
  });
  const [, drop] = useDrop({
    accept: ItemTypes.FIELD,
    hover(item) {
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex !== hoverIndex) {
        moveField(dragIndex, hoverIndex);
        item.index = hoverIndex;
      }
    },
  });
  drop(ref);
  drag(ref);
  return (
     <Paper
      ref={ref}
      elevation={1}
      sx={{
        position: "relative",
        p: 2,
        mb: 1,
        borderRadius: 1,
        cursor: "move",
        opacity: isDragging ? 0.5 : 1,
        transition: "box-shadow 0.2s, transform 0.2s",
        "&:hover": {
          boxShadow: 2,
          transform: "translateY(-2px)",
        },
      }}
    >
      {/* remove‐field button */}
      <IconButton
        size="small"
        onClick={onRemove}
        sx={{
          position: "absolute",
          top: 4,
          right: 4,
          bgcolor: "rgba(0,0,0,0.05)",
          "&:hover": { bgcolor: "rgba(0,0,0,0.1)" },
        }}
      >
        <DeleteIcon size={16} />
      </IconButton>

      {/* the wrapped field component */}
      <Box sx={{ mt: 1 /* so content sits below the icon */ }}>
        {children}
      </Box>
    </Paper>
  );
};
